import { Link } from "react-router-dom";
import NavBar from "@/components/NavBar";
import SEOHead from "@/components/SEOHead";
import BreadcrumbSEO from "@/components/BreadcrumbSEO";
import Footer from "@/components/Footer";

const About = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Sobre CompresorJPEG | Compresor de Imágenes Online Gratis"
        description="Conoce quién está detrás de CompresorJPEG, una herramienta gratuita para comprimir imágenes y mejorar el rendimiento web. Creada por Javier Treviño desde Monterrey, México."
        keywords="sobre compresorjpeg, compresor imagenes online, optimización web, rendimiento web, comprimir imágenes"
        canonical="https://compresorjpeg.com/about"
      />
      <NavBar />

      <div className="container mx-auto px-4">
        <BreadcrumbSEO
          items={[
            { label: "Inicio", href: "/" },
            { label: "Sobre nosotros" },
          ]}
        />
      </div>

      <main className="container mx-auto px-4 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold text-foreground mb-8">Sobre CompresorJPEG</h1>

        <div className="space-y-10 text-muted-foreground leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">¿Qué es CompresorJPEG?</h2>
            <p>
              CompresorJPEG.com es una herramienta online diseñada para comprimir imágenes de forma rápida, 
              sencilla y eficiente, ayudando a mejorar el rendimiento web sin sacrificar calidad.
            </p>
            <p className="mt-3">
              Está pensada para desarrolladores, creadores de contenido y cualquier persona que necesite 
              optimizar imágenes para sitios web, aplicaciones o proyectos digitales.
            </p>
            <p className="mt-3">
              CompresorJPEG.com es un proyecto creado por <strong>Javier Treviño</strong>, ingeniero de software en Monterrey, México.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">Misión</h2>
            <p>
              La misión de CompresorJPEG es facilitar la optimización web a través de herramientas simples, 
              rápidas y accesibles, enfocadas en mejorar la velocidad de carga y la experiencia del usuario.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">Quién está detrás</h2>
            <p>
              Este proyecto fue creado por <strong>Javier Treviño</strong>, ingeniero de software ubicado en 
              Monterrey, México, con experiencia en arquitectura de sistemas, rendimiento y desarrollo de 
              soluciones escalables.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">Por qué existe este sitio</h2>
            <p>
              Este sitio nace de la necesidad de contar con una herramienta rápida y confiable para optimizar 
              imágenes sin depender de plataformas lentas o complejas.
            </p>
            <p className="mt-3">
              Después de trabajar con problemas de rendimiento web en distintos proyectos, se volvió claro que 
              optimizar imágenes debería ser un proceso simple, rápido y accesible para cualquier usuario.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">Privacidad y seguridad</h2>
            <p>
              La privacidad es una prioridad.
            </p>
            <p className="mt-3">
              Las imágenes se procesan de forma segura y no se almacenan permanentemente. No se comparten 
              con terceros ni se conservan después del procesamiento.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">En evolución</h2>
            <p>
              CompresorJPEG es un proyecto en constante crecimiento.
            </p>
            <p className="mt-3">
              Se seguirán agregando nuevas herramientas, mejoras en el procesamiento y contenido educativo 
              enfocado en optimización web, rendimiento y mejores prácticas digitales.
            </p>
            <p className="mt-3">
              Enfocado en optimización web, rendimiento y experiencia del usuario.
            </p>
          </section>

          <div className="pt-8 border-t border-border">
            <p className="text-sm text-muted-foreground">
              Proyecto creado por <strong className="text-foreground">Javier Treviño</strong> — Monterrey, México
            </p>
            <p className="mt-4 text-sm">
              <Link to="/contact" className="text-primary hover:underline">
                Contacto
              </Link>
              {" · "}
              <Link to="/privacidad" className="text-primary hover:underline">
                Política de Privacidad
              </Link>
              {" · "}
              <Link to="/" className="text-primary hover:underline">
                Ir al compresor
              </Link>
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default About;
